import { useTranslation } from 'react-i18next';
import { useParticipationTableContext } from 'pages/Dashboard/Sessions/Details/components/ParticipationsTable/ParticipationTableContext';
import { TableColumnHeader } from 'pages/Dashboard/Sessions/Details/components/ParticipationsTable/TableColumnHeader';
import { TableParticipationHeader } from 'pages/Dashboard/Sessions/Details/components/TableParticipationHeader';
import { FieldType, IndexedParticipation } from '@app/api';
import { Filter } from 'pages/Dashboard/Sessions/Details/components/Filter';
import { useIndexedParticipationDisplayName } from '@app/core';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';

const useStyles = createUseStyles((theme: Theme) => ({
  nameContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.marginBase,
  },
  highlighted: {
    display: 'inline-block',
    width: theme.marginBase,
    height: theme.marginBase,
    backgroundColor: theme.colors.red,
    borderRadius: '50%',
  },
}));

export const NameHeader = () => {
  const { t } = useTranslation();
  const { session, filtering, sorting } = useParticipationTableContext();

  return (
    <th key="name">
      <TableColumnHeader>
        <TableParticipationHeader
          fieldKey="firstname"
          fieldType={FieldType.SHORT_TEXT}
          currentSort={sorting.sort}
          onSortClick={sorting.handleSortClick}
        >
          <span>{t('sessions.details.participantsDetails.columns.name')}</span>
        </TableParticipationHeader>
        <Filter
          fieldRef="firstname|lastname"
          fieldLabel={t('sessions.details.participantsDetails.columns.name')}
          fieldType={FieldType.SHORT_TEXT}
          sessionId={session.id}
          currentFilterData={filtering.getFieldCurrentFilter(
            'firstname|lastname',
          )}
          onFilterDataChange={filtering.handleFilterChange}
        />
      </TableColumnHeader>
    </th>
  );
};

export const NameCell = ({
  participation,
}: {
  participation: IndexedParticipation;
}) => {
  const { special } = useParticipationTableContext();
  const classes = useStyles();
  const name = useIndexedParticipationDisplayName(participation);

  return (
    <td key="name">
      <div className={classes.nameContainer}>
        {special.rendering?.idsToHighlight?.includes(participation.id) && (
          <span className={classes.highlighted} />
        )}
        <span>{name}</span>
      </div>
    </td>
  );
};
